import { render, staticRenderFns } from "./roleLimits.vue?vue&type=template&id=f15a759a&scoped=true"
import script from "./roleLimits.vue?vue&type=script&lang=js"
export * from "./roleLimits.vue?vue&type=script&lang=js"
import style0 from "./roleLimits.vue?vue&type=style&index=0&id=f15a759a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15a759a",
  null
  
)

export default component.exports